"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplitudeLog = void 0;
var amplitude = require("@amplitude/analytics-browser");
var plugin_web_attribution_browser_1 = require("@amplitude/plugin-web-attribution-browser");
var AmplitudeLog = /** @class */ (function () {
    function AmplitudeLog(amplitude_key) {
        var _this = this;
        this.setEventDate = function (date) {
            var identifyEvent = new _this._client.Identify();
            identifyEvent.set('event_date', date.toISOString().split('T')[0]);
            _this._client.identify(identifyEvent);
        };
        this.send = function (key, data) {
            if (data === void 0) { data = {}; }
            _this.setEventDate(new Date());
            _this._client.track(key, data);
        };
        this.useSendBeacon = function () {
            _this._client.setTransport('beacon');
            _this._client.flush();
        };
        this.getInstance = function () {
            return _this._client;
        };
        // @ts-ignore
        amplitude.add((0, plugin_web_attribution_browser_1.webAttributionPlugin)());
        amplitude.init(amplitude_key);
        this._client = amplitude;
    }
    return AmplitudeLog;
}());
exports.AmplitudeLog = AmplitudeLog;
//# sourceMappingURL=amplitude.js.map